import type { NotificationItem } from './types'

export type NotificationListEntry =
  | { kind: 'single'; item: NotificationItem }
  | { kind: 'group'; key: string; items: NotificationItem[] }

/**
 * Группируем только три и более соседних строк в пределах уже загруженной
 * страницы. Группа на границе следующей страницы объединится после load more.
 */
export function groupConsecutiveNotifications(items: NotificationItem[]): NotificationListEntry[] {
  const result: NotificationListEntry[] = []
  let index = 0

  while (index < items.length) {
    const current = items[index]
    if (!current.group_key) {
      result.push({ kind: 'single', item: current })
      index += 1
      continue
    }

    let end = index + 1
    while (end < items.length && items[end].group_key === current.group_key) end += 1
    const grouped = items.slice(index, end)
    if (grouped.length >= 3) {
      result.push({ kind: 'group', key: `${current.group_key}:${current.id}`, items: grouped })
    } else {
      grouped.forEach((item) => result.push({ kind: 'single', item }))
    }
    index = end
  }

  return result
}
